import { render } from "./Influencers.vue?vue&type=template&id=fa193b46"
import script from "./Influencers.vue?vue&type=script&lang=js"
export * from "./Influencers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__